import { render } from "./UnsubscribeNotificationConfirmation.vue?vue&type=template&id=33b0a14f"
import script from "./UnsubscribeNotificationConfirmation.vue?vue&type=script&lang=js"
export * from "./UnsubscribeNotificationConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__